<template>
  <div>
    <el-form label-position="left" label-width="130px">
      <el-form-item label="App名称">
        <zt-input v-model="info.app_name" disabled></zt-input>
      </el-form-item>
      <el-form-item label="App图标" class="upload">
        <upload :src="info.app_icon" text="更换图标" @changeUrl="changeUrl" disabled></upload>
        <!-- <span class="tips">显示在个人中心的联系客服页</span> -->
      </el-form-item>
      <el-form-item label="App简介">
        <zt-input v-model="info.app_introduce" disabled type="textarea" :rows="4"></zt-input>
      </el-form-item>
      <el-form-item label="百川 App_key">
        <zt-input v-model="info.baichuan_app_key" disabled></zt-input>
      </el-form-item>
      <!-- <el-form-item label="百川 App_secret">
        <zt-input type="textarea" :rows="4"></zt-input>
      </el-form-item>-->
      <el-form-item label="安卓下载地址">
        <zt-input v-model="info.android_demo_url" disabled></zt-input>
      </el-form-item>
      <el-form-item label="iOS下载地址">
        <zt-input v-model="info.ios_demo_url" disabled></zt-input>
      </el-form-item>
      <el-form-item label="安卓包名">
        <zt-input v-model="info.android_package_name" disabled></zt-input>
        <zt-button type="text" class="copy" v-copy="info.android_package_name">复制</zt-button>
      </el-form-item>
      <!-- <el-form-item label="安卓签名">
        <zt-input disabled></zt-input>
        <zt-button type="text" class="copy" v-copy="copyText">复制</zt-button>
      </el-form-item>-->
      <el-form-item label="安卓市场渠道">
        <div class="market" v-for="(item,idx) in marketList" :key="idx">
          <span class="market-name">{{item.market}}</span>
          <zt-input v-model="item.ver" disabled></zt-input>
          <el-upload
            action
            class="upload-demo"
            ref="upload"
            :on-change="(file)=> { handleUploadchange(item,file,idx) }"
            :auto-upload="false"
          >
            <el-progress
              color="#B27DFF"
              type="circle"
              :width="30"
              :percentage="progressList[idx]"
              v-if="progressList[idx]===0||progressList[idx]"
            ></el-progress>
            <zt-button
              slot="trigger"
              class="download"
              :disabled="progressState[idx]==1"
            >{{progressState[idx]==1?'上传中':progressState[idx]==2?'上传失败':'上传安装包'}}</zt-button>
          </el-upload>
          <a :href="item.link" target="_blank" class="link">前往市场官网</a>
        </div>
      </el-form-item>

      <el-form-item label="iOS渠道">
        <div class="market">
          <span class="market-name">applestore</span>
          <zt-input v-model="appStoreData.ver" disabled></zt-input>
          <el-upload
            action
            class="upload-demo"
            ref="upload"
            :on-change="(file)=> { handleUploadIosChange(appStoreData,file) }"
            :auto-upload="false"
          >
            <el-progress
              color="#B27DFF"
              type="circle"
              :width="30"
              :percentage="iosProgress"
              v-if="iosProgress===0||iosProgress"
            ></el-progress>
            <zt-button
              slot="trigger"
              class="download"
              :disabled="iosProgressState==1"
            >{{iosProgressState==1?'上传中':iosProgressState==2?'上传失败':'上传安装包'}}</zt-button>
          </el-upload>
          <a href="https://developer.apple.com/" target="_blank" class="link">前往市场官网</a>
        </div>
      </el-form-item>

      <!-- <el-form-item>
        <zt-button type="primary" class="save">保存</zt-button>
      </el-form-item>-->
    </el-form>
  </div>
</template>

<script>
import upload from '@cps/Upload/upload';
import { copy } from '@/directive/copy';
// import { admin_plugin_app_upload } from "@/api/appAdminManage";
import { post } from '@/utils/request';

export default {
  directives: { copy },
  components: { upload },
  data: () => ({
    iosProgress: '',
    iosProgressState:'',
    progressState: [],
    progressList: [],
    marketList: [],
    src: '',
    linkList: {
      360: 'http://dev.360.cn/',
      应用宝: 'http://op.open.qq.com/',
      小米: 'https://dev.mi.com/console/',
      华为: 'http://developer.huawei.com/',
      oppo: 'http://open.oppomobile.com/',
      vivo: 'https://id.vivo.com.cn/',
    },
    appStoreData: {},
  }),
  props: {
    info: {
      type:Object,
      default:() => ({
        android_market:[],
        appfiles:[],
      }),
    },
  },
  watch: {
    info: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val.status == 0) { return }
        this.marketList = [];
        val.android_market.map((arr) => {
          this.progressState.push(0);
          this.progressList.push('');
          this.marketList.push({
            market: arr,
            link: this.linkList[arr],
          });
        });
        this.marketList.map((arr) => {
          val.appfiles.map((file) => {
            if (arr.market == file.market) {
              arr.ver = file.ver;
            }
          });
        });
        val.appfiles.map((arr) => {
          if (arr.market == 'applestore') {
            this.appStoreData = arr;
          }
        });
      },
    },
  },
  methods: {
    handleUploadchange(item, file, idx) {
      let that = this;
      post(
        'admin_plugin_app_upload',
        {
          id: this.info.id,
          market: item.market,
          appfile: file.raw,
        },
        {
          clear: false,
          config: {
            timeout: 100000,
            transformRequest: [
              (data) => {
                // data => formdata
                let formD = new FormData();
                Object.keys(data).forEach((key) => {
                  if (data[key] !== null) {
                    formD.append(key, data[key]);
                  }
                });
                return formD;
              },
            ],
            onUploadProgress: (progressEvent) => {
              var complete =
                ((progressEvent.loaded / progressEvent.total) * 100) | 0;
              that.progressList.splice(idx, 1, complete);
              that.progressState.splice(idx, 1, 1);
            },
          },
        }
      )
        .then(({ data }) => {
          this.progressState.splice(idx, 1, 0);
          if (data.error_code == 0) {
            this.$message.success('上传成功');
            this.$emit('updata');
            this.progressList = [];
            this.progressState = [];
          } else {
            if (data.error_code == 5) {
              this.progressList = [];
              this.progressState = [];
            }
            this.$message.error(data.error_message);
          }
        })
        .catch(() => {
          this.progressState.splice(idx, 1, 2);
        });
    },
    handleUploadIosChange(item, file) {
      let that = this;
      post(
        'admin_plugin_app_upload',
        {
          id: this.info.id,
          market: 'applestore',
          appfile: file.raw,
        },
        {
          clear: false,
          config: {
            timeout: 100000,
            transformRequest: [
              (data) => {
                // data => formdata
                let formD = new FormData();
                Object.keys(data).forEach((key) => {
                  if (data[key] !== null) {
                    formD.append(key, data[key]);
                  }
                });
                return formD;
              },
            ],
            onUploadProgress: (progressEvent) => {
              var complete =
                ((progressEvent.loaded / progressEvent.total) * 100) | 0;
              that.iosProgress = complete;
              that.iosProgressState = 1;
            },
          },
        }
      )
        .then(({ data }) => {
          that.iosProgressState = 0;
          if (data.error_code == 0) {
            this.$message.success('上传成功');
            this.$emit('updata');
            this.iosProgress = '';
            this.iosProgressState = '';
          } else {
            if (data.error_code == 5) {
              this.iosProgress = '';
              this.iosProgressState = '';
            }
            this.$message.error(data.error_message);
          }
        })
        .catch(() => {
          this.iosProgress = 2
        });
    },
    changeUrl(url) {
      this.src = url;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-progress {
  position: absolute;
  top: 5px;
  left: 300px !important;
}
/deep/ .el-upload-list__item {
  display: none;
}
.upload-demo {
  display: inline-block;
}
.save {
  width: 143px;
  height: 40px;
}
.market-name {
  display: inline-block;
  width: 80px;
  font-size: 14px;
  color: #232526;
}
.download {
  vertical-align: middle;
  width: 139px;
  height: 40px;
  border-radius: 2px;
  border: 1px solid $theme;
  display: inline-block;
  color: $theme;
  text-align: center;
  margin-left: 16px;
}
.copy {
  margin-left: 10px;
}
.link {
  vertical-align: middle;
  margin-left: 11px;
  color: $theme;
}
.market {
  position: relative;
  margin-top: 16px;
}
.tips {
  color: $theme-textsecond;
  font-size: 12px;
  line-height: 12px;
  vertical-align: 5px;
}
.market:first-child {
  margin-top: 0px;
}
/deep/ .zt-input {
  width: 511px;
}
.market /deep/ .zt-input {
  width: 285px;
}
.btn {
  width: 143px;
  height: 40px;
}
.save-tips {
  margin-left: 24px;
  color: $theme;
  font-size: 14px;
}
/deep/ .el-form-item__label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(35, 37, 38, 1);
}
</style>